import { PermissionUtil, UserSessionStore } from '@aon/aon-tws-common-ui';
import adminportalLogo from '@aon/aon-tws-common-ui/build/lib/assets/images/logo-adminPortal.svg';
import massMailLogo from '@aon/aon-tws-common-ui/build/lib/assets/images/logo-massMail.svg';
import monitoringLogo from '@aon/aon-tws-common-ui/build/lib/assets/images/logo-monitor.svg';
import orgmanagerLogo from '@aon/aon-tws-common-ui/build/lib/assets/images/logo-orgManager.svg';
import questionlibraryLogo from '@aon/aon-tws-common-ui/build/lib/assets/images/logo-questionLibrary.svg';
import navGridImage from '@aon/aon-tws-common-ui/build/lib/assets/images/nav-grid.svg';
import navHelpImage from '@aon/aon-tws-common-ui/build/lib/assets/images/nav-help.svg';
import navHomeImage from '@aon/aon-tws-common-ui/build/lib/assets/images/nav-home.svg';
import { User } from 'oidc-client';
import { connect } from 'react-redux';
import { Layout } from '../../components/layout/Layout';
import constants from '../../constants';
import { IApplicationState } from '../../store';
import { NavigationActions } from '../../store/NavigationActions';
import userManager from '../../userManager';
import { actionCreators } from './LayoutStore';

const logoutOnClick = (event: any) => {
	event.preventDefault();

	UserSessionStore.logout(userManager, constants.IDENTITY_SERVER_URL);
};
const getUserApplications = (items: any[], user?: User) => {
	const apps = PermissionUtil.GetUserApplications(user);
	return items.filter((item) => apps.indexOf(item.app) > -1);
};

const popupMenuItems = [
	{ href: constants.ORGMANAGER_URL, src: orgmanagerLogo, app: 'HierarchyManagerAPI' },
	{ href: constants.ADMINPORTAL_URL, src: adminportalLogo, app: 'UserManagementAPI' },
	{ href: constants.QUESTIONLIBRARY_URL, src: questionlibraryLogo, app: 'QuestionLibraryAPI' },
	{ href: constants.MONITORING_URL, src: monitoringLogo, app: 'MonitoringAPI' },
	{ href: constants.MASSMAIL_URL, src: massMailLogo, app: 'MassMailAPI' },
];

const linkMenuItems = [
	{ href: constants.HELP_SITE_URL, text: 'Help', target: '_blank' },
	{ href: constants.CONTACT_SUPPORT_URL, text: 'Contact Support', target: '_blank' },
];

export const mapStateToProps = (state: IApplicationState) => ({
	user: state.oidc.user,
	headerMenuItems: [
		{ href: '/', src: navHomeImage, altText: '' },
		{ href: '#', src: navGridImage, altText: '', popupMenuItems: getUserApplications(popupMenuItems, state.oidc.user) },
		{ href: '#', src: navHelpImage, altText: '', linkMenuItems },
	],
	loggedInUserMenuOptions: [
		{
			name: 'Logout',
			onClick: logoutOnClick,
			href: '#',
		},
	],
	notifications: state.notifications,
	...actionCreators,
});

export const LayoutContainer: React.ComponentType<any> = connect(mapStateToProps, {
	...NavigationActions,
	logout: UserSessionStore.logout,
})(Layout as any);
